import React, { useState } from "react";
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.us";
import TextField from "@mui/material/TextField";

const DEFAULT_OPTIONS = {
  delimiters: ["(", ") ", "-"],
  blocks: [0, 3, 3, 4],
  numericOnly: true,
};

const PhoneWidget = ({
  id,
  value = "",
  required,
  label = "Phone Number",
  onChange,
  disabled = false,
  readonly = false,
  hideError = false,
  rawErrors = [],
}) => {
  const [focused, setFocused] = useState(false);
  const isDisabled = disabled || readonly;
  const showError = !hideError && rawErrors.length > 0;

  return (
    <TextField
      id={id}
      name={id}
      label={label}
      required={required}
      error={showError}
      helperText={showError ? "" : " "}
      fullWidth
      autoComplete="tel"
      disabled={isDisabled}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      InputLabelProps={{
        shrink: focused || Boolean(value), 
      }}
      InputProps={{
        inputComponent: CleaveInput,
        inputProps: {
          value: typeof value === "string" ? value : "",
          onChange: (e) => onChange(e.target.value),
          options: DEFAULT_OPTIONS,
        },
      }}
    />
  );
};

const CleaveInput = React.forwardRef(function CleaveInput(props, ref) {
  const {
    inputRef,
    options = DEFAULT_OPTIONS,
    value = "",
    onChange = () => {},
    ...other
  } = props;

  return (
    <Cleave
      {...other}
      value={typeof value === "string" ? value : ""}
      options={options}
      onChange={onChange}
      htmlRef={(r) => {
        if (typeof inputRef === "function") inputRef(r);
        else if (inputRef?.current) inputRef.current = r;
        if (typeof ref === "function") ref(r);
        else if (ref?.current) ref.current = r;
      }}
    />
  );
});

export default PhoneWidget;
